import { render, staticRenderFns } from "./CreatePolicyModal.vue?vue&type=template&id=c0c05544&scoped=true"
import script from "./CreatePolicyModal.vue?vue&type=script&lang=ts"
export * from "./CreatePolicyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c05544",
  null
  
)

export default component.exports